<template>
  <v-app >
    <header-app v-if="oneUser"></header-app>

    <v-content >
      <router-view />
    </v-content>

    <footer-app v-if="!is_mobile"></footer-app>
  </v-app>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  components: {
    HeaderApp: () => import('./components/shared/Header'),
    FooterApp: () => import('./components/shared/Footer'),
  },
  name: 'App',
  data: () => ({
    //
  }),
  computed: {
    is_mobile() {
      return document.body.clientWidth < 720
    },
    is_ready() {
      return this.$auth.check()
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
    })
  },
  methods: {
    ...mapActions({
      setUser: 'User/setUser',
      setProfile: 'User/setProfile',
    }),
  },
  watch: {
    is_ready(nv,ov) {
      if (nv){
        this.setUser(this.$auth.user())
        this.setProfile(this.$auth.user())
      } else if (nv == false){

      }
    }
  },
};
</script>
